export enum BilingualEvent {
  TEACHER_TYPE = 'TEACHER_TYPE',
  BILINGUAL_FALLBACK = 'BILINGUAL_FALLBACK',
}
